import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StatusCardGridWrapper = styled(Box)({
  containerType: 'inline-size',
  width: '100%',
  marginBottom: '40px',
});

export const StatusCardGridContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  width: '100%',
  gap: theme.spacing(2),
  gridTemplateColumns: 'repeat(4, 1fr)',

  '@container (max-width: 600px)': {
    gridTemplateColumns: '1fr',
  },
  '@container (min-width: 600px) and (max-width: 1200px)': {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
}));
